import type { PostEventAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'
import type { PostEventType } from '@/client/services/worlds'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import PostQ from './PostQ'
import UserQ from './UserQ'

const PostEventQ = {
  ...makeQueryModelV2<PostEventAttributes>('post_event')([
    'id',
    'post_id',
    'user_id',
    'type',
    'body',
    'attachment_urls',
    'is_collapsible',
    'hidden_at',
    'created_at',
    'updated_at',
    'deleted_at',
  ]),

  associations: (): AssociationDefinitions => ({
    Post: {
      query: PostQ,
      foreignKey: PostQ.id,
      sourceKey: PostEventQ.post_id,
    },
    User: {
      query: UserQ,
      foreignKey: UserQ.id,
      sourceKey: PostEventQ.user_id,
    },
  }),

  where: (
    {
      id,
      postId,
      userId,
      type,
      groupBy = null,
      include = [],
      order = null,
      paranoid = true,
    }: {
      id?: number | null | SQLFragment<number>
      postId?: number | null | SQLFragment<number>
      userId?: number | null | SQLFragment<number>
      type?: PostEventType | null | SQLFragment<PostEventType>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
      include?: IncludeAssociations
      paranoid?: boolean
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<PostEventAttributes> => SQL`
        FROM ${PostEventQ}
        ${includeAssociationsToSql(PostEventQ, include)}
        WHERE
            ${id != null ? SQL`${PostEventQ.id} = ${id} AND` : SQL``}
            ${postId != null ? SQL`${PostEventQ.post_id} = ${postId} AND` : SQL``}
            ${userId != null ? SQL`${PostEventQ.user_id} = ${userId} AND` : SQL``}
            ${type != null ? SQL`${PostEventQ.type} = ${type} AND` : SQL``}
            ${paranoid ? SQL`${PostEventQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default PostEventQ
